<template>
    <div>
        <table class="">
            <tr v-for="(batch, index) in data.batches" :key="index">
              <td>
                <label>Batch Number</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Batch Number"
                  v-model="batch.BatchNumber" 
                  required
                />
              </td>
              <td>
                <label>Quantity</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Quantity"
                  v-model="batch.Quantity"
                  required
                />
              </td>
              <td>
                <label>MFGDate</label>
                <input
                type="date"
                class="form-control"
                placeholder="MFG"
                v-model="batch.MFGDate" />
              </td>
              <td>
                <label>Expiry Date</label>
                <input
                type="date"
                class="form-control"
                placeholder="Expiry"
                v-model="batch.ExpiryDate"/>
              </td>
              <td >
                    <a class="mt-5 btn btn-sm btn-danger text-white" @click="removeRow(index)">Delete</a>
                </td>
            </tr>
            <tr>
                <td colspan="5">
                    <div class="text-right">

          <span
                  class="btn btn-sm btn-info mt-3 btn-add-new-batch"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Add new Batch"
                  v-on:click="addNewBatchRow(ItemId)"
                >
                  <i class="fa fa-plus-circle"></i>
                </span>
          </div>
                </td>
            </tr>
          </table>

    </div>
</template>

<script>
    export default {
        name: 'delivery-challan-item-batch',
        props : ['ItemId'],
        data() {
            return {
              data : {
                ItemId : this.ItemId,
                batches: [{
                    BatchNumber: null,
                    Quantity: 0,
                    MFGDate: null,
                    ExpiryDate: null,
                }]
              },

            }
        },
        methods: {
            addNewBatchRow: function(itemId){
                this.data.batches.push(
                  {
                      BatchNumber: null,
                      Quantity: 0,
                      MFGDate: null,
                      ExpiryDate: null
                });

                this.data.batches = this.checkUniqueBatches(this.data.batches, 'BatchNumber')
            },
            removeRow: function(row){
                this.data.batches.splice(row, 1);
            },
            checkUniqueBatches: function(arr, key){
                var uniqueBatches = [...new Map(arr.map(item => [item[key], item])).values()]
                return uniqueBatches;
            }
        },
    }
</script>

<style lang="scss" scoped>
.btn-add-new-batch{
    // position: absolute;
    // right: 135px;
}
</style>
